<div class="ui-g">
  <div class="ui-g-12">
    <div class="card card-w-title">
      <h1>Manage Vehicle Types</h1>
      <p-table
        #dt
        selectionMode="single"
        [value]="page.items"
        [lazy]="true"
        [rows]="10"
        [responsive]="true"
        [paginator]="true"
        rowHover="true"
        resizableColumns="true"
        [totalRecords]="page.total"
        (onLazyLoad)="onGridLazyLoad($event)"
        (onRowSelect)="onRowSelect($event)"
        *ngIf="isLoaded; else loading"
      >
        <ng-template pTemplate="header">
          <tr>
            <th pSortableColumn="name">Name</th>
            <th pSortableColumn="description">Description</th>
            <th pSortableColumn="isActive">Active</th>
          </tr>
          <tr>
            <th><input (input)="dt.filter($event.target.value, 'name', 'startsWith')" /></th>
            <th><input (input)="dt.filter($event.target.value, 'description', 'startsWith')" /></th>
            <th></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-item>
          <tr [pSelectableRow]="item" (dblclick)="onRowDblclick(item)">
            <td>{{ item.name }}</td>
            <td>{{ item.description }}</td>
            <td>{{ item.isActive }}</td>
          </tr>
        </ng-template>
      </p-table>
      <!--- DATATABLES DEPRECATED ----
            <p-dataTabl selectionMode="single" [value]="page.items" [lazy]="true" [rows]="10" [responsive]="true" [paginator]="true" rowHover="true" resizableColumns="true"
                         [totalRecords]="page.total" (onLazyLoad)="onGridLazyLoad($event)" (onRowSelect)="onRowSelect($event)" (onRowDblclick)="onRowDblclick($event)"
                         *ngIf="isLoaded; else loading">
                <p-header>List of Vehicle Types</p-header>
                <p-column field="name" header="Name" [filter]="true" filterPlaceholder="Search contains" filterMatchMode="contains" [sortable]="tru" [editable]="false" [style]="{'width': '45%'}"></p-column>
                <p-column field="description" header="Description" [filter]="true" filterPlaceholder="Search contains" filterMatchMode="contains" [sortable]="tru" [editable]="false" [style]="{'width': '45%'}"></p-column>
                <p-column field="isActive" header="Active" [sortable]="tru" [editable]="false" [style]="{'width': '10%'}"></p-column>
            </p-dataTable>
            ---->

      <div class="footerPanel ui-grid-row">
        <button
          type="button"
          class="btn-to-right"
          pButton
          (click)="onEdit()"
          label="Edit"
          icon="fa ui-icon-mode-edit"
        ></button>
        <button
          type="button"
          class="btn-to-right"
          pButton
          icon="fa ui-icon-add"
          (click)="showDialogToAdd()"
          label="Add"
        ></button>
      </div>

      <p-dialog
        header="Vehicle Type"
        [(visible)]="displayDialog"
        [responsive]="true"
        [modal]="true"
        [style]="{ width: '400px' }"
      >
        <form
          [formGroup]="newVehicleTypeForm"
          (ngSubmit)="save(newVehicleTypeForm.value)"
          autocomplete="off"
        >
          <div class="ui-grid ui-grid-responsive ui-fluid" *ngIf="vehicle">
            <div class="ui-g-12">
              <div class="ui-g-4"><label for="name">Name</label></div>
              <div class="ui-g-8"><input pInputText id="name" formControlName="name" /></div>
            </div>
            <div class="ui-g-12">
              <div class="ui-g-4"><label for="description">Description</label></div>
              <div class="ui-g-8">
                <input pInputText id="description" formControlName="description" />
              </div>
            </div>
            <div class="ui-g-12">
              <div class="ui-g-4"><label for="isactive">Active</label></div>
              <div class="ui-g-8">
                <p-checkbox name="isActive" binary="true" formControlName="isActive"></p-checkbox>
              </div>
            </div>
          </div>
          <div style="float: right">
            <button
              type="submit"
              class="green-btn"
              pButton
              icon="fa ui-icon-check"
              label="Save"
              [disabled]="newVehicleTypeForm.invalid"
            ></button>
            <button
              type="button"
              pButton
              icon="fa ui-icon-close"
              label="Cancel"
              (click)="close()"
            ></button>
          </div>
        </form>
      </p-dialog>
    </div>
  </div>
</div>
<ng-template #loading>Loading...</ng-template>
